import showToast from 'lib/toast_notification';

export default function initPatientDocumentTags() {
  $(document).off('ajax:success.docTag ajax:error.docTag');

  $(document).on('ajax:success.docTag', '.doc-tag-form', (event) => {
    const [data] = event.detail;
    const $row = $(event.target).closest('tr');
    const needs = !!(data?.requires_start_date ?? data?.document_tag_type?.expiration_alert);

    $row.find('.js-doc-tag-date').toggleClass('d-none', !needs);
    $row.find('.js-doc-tag-na').toggleClass('d-none', needs);

    if (needs && data?.start_date) {
      $row.find('.js-doc-tag-date').val(data.start_date);
    }

    showToast(data?.message || 'Saved', { type: 'success', delay: 5000 });
  });

  $(document).on('ajax:error.docTag', '.doc-tag-form', () => {
    showToast('Update failed. Please try again.', { type: 'error', delay: 5000 });
  });
}
